import { misc } from '@otto-ec/global-resources/misc';
import { type Action, type Feature, type MiniAction, tracking } from '@otto-ec/tracking-bct';
import { type KnownTrackingLabels, type TrackingLabels, convertLabelsToDataContainer } from './TrackingLabels';

/**
 *
 *
 */
class Tracking {
    submitEvent(labels: KnownTrackingLabels): void {
        tracking.submitEvent(convertLabelsToDataContainer(labels));
    }

    addToPageImpression(labels: TrackingLabels, features?: Feature[]): void {
        tracking.submitMerge(convertLabelsToDataContainer(labels), features);
    }

    trackOnNextPageImpression(labels: TrackingLabels): void {
        tracking.trackOnNextPageImpression(convertLabelsToDataContainer(labels));
    }

    submitAction(labels: KnownTrackingLabels, action: Action): void {
        tracking.submitEvent(convertLabelsToDataContainer(labels), action);
    }

    submitMiniActions(miniActions: MiniAction[]): void {
        tracking.submitMiniAction(miniActions);
    }

    async getPageMergeId(): Promise<string> {
        return tracking.getPageMergeId().then((mergeId) => mergeId ?? misc.guid());
    }
}

export default new Tracking();
